import React, { useEffect, useCallback} from "react"

import { useTranslation } from "react-i18next"
import { useStateConnectedToCache } from "../../../Utils/requestUtils"

import Filter from "./Filter"
import Pagination from "@material-ui/lab/Pagination"
import { CircularProgress } from "@material-ui/core"
import axios from "axios"
import ErrorBoundary from "../../../Utils/ErrorBoundary"
import CardListHeader from "./CardListHeader"
import CoafBatchCard from "./CoafBatchCard"


function CoafBatchesInbox(props) {
    const { t } = useTranslation()
    const { pageState, dispatchPageState, setSnackbarContent, toggleBatches } = props

    const local_storage_object_preffix = "coaf_batch_inbox"

    const [pageParams, setPageParams] = useStateConnectedToCache(
        local_storage_object_preffix
    )

    const doRequest = useCallback(
        (payload) => {
            dispatchPageState({type: "data_fetch_init"})
            axios.get("/dash/alerts/occurrence_batch", {
                params: payload
            }).then(response=>{
                dispatchPageState({
                    type: "data_fetch_success",
                    payload: response.data
                })
            }).catch(error => {
                if ((error.response || {}).status === 403) dispatchPageState({type: "data_fetch_failure_403"})
                else if ((error.response || {}).status === 404) dispatchPageState({type: "data_fetch_failure_404"})
                else dispatchPageState({type: "data_fetch_failure"})
            })
        },[dispatchPageState]
    )

    useEffect(() => {
        let payload = {
            "page_number": pageParams.page - 1,
            "page_rows": 25,
        }
        Object.keys(pageParams.filters).forEach((key, _) => {
            payload[key] = pageParams.filters[key]
        })
        const timer_ = setTimeout(() => {
            doRequest(payload)
        }, 300)
        return () => {
            clearTimeout(timer_)
		}
    },[doRequest, pageParams, toggleBatches])

    const handleChangePage = (event, page, filters) => {
		if (pageState.page === page) {
			return
		}
		setPageParams({page: page, filters: filters})
	}


    const contentContainer = (dataList) => {
		let nr_of_cards = dataList['occurrence_batches'].length
		let cards = dataList['occurrence_batches'].map((batch) => (
			<ErrorBoundary key={batch.occurrence_batch_key}>
				<CoafBatchCard
                    setBatchDialogState={props.setBatchDialogState}
                    flexColumnStyles={props.flexColumnStyles}
                    batch={batch}
                    setSnackbarContent={setSnackbarContent}
                    refreshList={() => doRequest({page_number: pageParams.page - 1, page_rows: 25, filters: pageParams.filters})}
                />
			</ErrorBoundary>
		))

		if (nr_of_cards === 0) {
			return (
			<div className='emptyContainer'>
				<p className={["blueText", "subtitleSize"].join(" ")}>
					{t("Nenhum Lote encontrado")}
				</p>
			</div>
			)
		}

		else {
            return (
                <div className='cardContainer'>
                    <CardListHeader
                        flexColumnStyles={props.flexColumnStyles}
                    />
                    {cards}
                </div>
            )
		}
	}

    if (pageState.fetchedData) {
        return (
            <>
                <ErrorBoundary doNothing>
                    <div style={{display:"flex"}}>
                        <Filter
                            local_storage_object_preffix={local_storage_object_preffix}
                            setPageParams={setPageParams}
                        />
                    </div>
                </ErrorBoundary>
                <div>{contentContainer(pageState.fetchedData)}</div>
                <div>
                    <Pagination
                        className="pagination"
                        page={pageParams.page}
                        count={parseInt(pageState.fetchedData["number_of_pages"])}
                        onChange={(e, page) => handleChangePage(e, page, pageParams.filters)}
                    />
                </div>
            </>
        )
    }
    else if (pageState.isError){
        return (
            <div style={{height: "55vh", display:"flex"}}>
                    <p className={["blueText", "titleSize"].join(" ")} style={{margin:"auto", textAlign:"center"}}>
                        {pageState.errorMessage}
                    </p>
                </div>
        )
    }
    else if (pageState.isLoading) {
        return(
            <div className='circularProgressCenter'>
                <CircularProgress />
            </div>
        )
    }
    else return null
}

export default CoafBatchesInbox